module.exports = "const TickTock = props => (\n  <div>\n    <h1>Hello, world!</h1>\n    <h2>The time is {props.time}.</h2>\n  </div>\n);\n\nfunction tick() {\n  const now = \n    new Date().toLocaleTimeString();\n\n  render(\n    <TickTock time={now} />,\n    mountNode\n  )  \n}\n\nsetInterval(tick, 1000);"


//////////////////
// WEBPACK FOOTER
// ./src/slides/08_clock/clock-live.example
// module id = 1512
// module chunks = 0